module.exports = __webpack_public_path__ + "img/logoTxt.73a7aba1.png";